<template>
  <v-layout fill-height column id="tutorialGuide07">
    <v-main class="page-mission page-mission-main tutorial-guide-content has-ticket">
      <v-layout fill-height column class="mission-main-contents">
        <v-container fluid class="mission-main-header">
          <h4 class="mission-main-title">
            🔎 내 마음, 나도 잘 모를 땐
          </h4>
          <section class="d-flex">
            <MissionCard v-bind="{ type: 'weather', write: false, typeCode: '' }" :busy="false" />
            <MissionCard v-bind="{ type: 'mindnote', write: false }" :busy="false" />
          </section>
        </v-container>
        <article class="mission-main-body" id="missionTutorialTarget03">
          <v-container fluid>

            <MissionAchievement :value="0" />

            <article class="mission-solution mt-3">
              <section class="mission-solution-content">
                <div class="mission-solution-header">
                  <h4 class="mission-solution-title">후유와 미션을 함께한 지</h4>
                  <div class="d-flex flex-grow-1 justify-end fs-15 fw-500">
                    <b class="badge-today">TODAY</b>
                    <b>1</b>일차
                  </div>
                </div>
                <div class="mission-date-groups ms-0">
                  <button class="mission-date-item selected">1</button>
                  <button class="mission-date-item">2</button>
                  <button class="mission-date-item">3</button>
                  <button class="mission-date-item">4</button>
                  <button class="mission-date-item">5</button>
                  <button class="mission-date-item">6</button>
                </div>
              </section>
              <section class="mission-solution-content">
                <div class="mission-solution-header">
                  <h4 class="mission-solution-title">1일차 미션</h4>
                </div>
              </section>
              <div class="solution-list">
                <template v-for="(solution, index) in solutions">
                  <div v-ripple class="solution-list-item solution-list-item--fixed" :key="index">
                    <v-avatar>
                      <v-img :src="getImage(helpfulIcon(solution.helpful))" />
                    </v-avatar>
                    <div class="unit-info">
                      <b class="unit-name">{{ solution.unitNm }}</b>
                      <span class="unit-type">{{ solution.unitTypeNm }} + {{solution.unitTypeCnt - 1}}</span>
                    </div>
                  </div>
                </template>
              </div>
            </article>

          </v-container>
        </article>
      </v-layout>
      <slot name="bottomMenu" />
    </v-main>

    <v-tooltip attach
               left
               max-width="100vw"
               class="tooltip-coach"
               :value="tooltipActive">
      <template v-slot:activator="{ attrs }">
        <MissionAchievement :value="50" v-bind="attrs"
                            id="MissionAchievement" />
      </template>
      <span class="tooltip-text" id="tooltipMissionAchievement">지금까지의 미션 수행률을<br />확인할 수 있어요!</span>
    </v-tooltip>
    <v-tooltip attach
               left
               max-width="100vw"
               class="tooltip-coach"
               :value="tooltipActive">
      <template v-slot:activator="{ attrs }">
        <article class="mission-solution mt-3" id="MissionSolutionList" v-bind="attrs">
          <section class="mission-solution-content">
            <div class="mission-solution-header">
              <h4 class="mission-solution-title">후유와 미션을 함께한 지</h4>
              <div class="d-flex flex-grow-1 justify-end fs-15 fw-500">
                <b class="badge-today">TODAY</b>
                <b>1</b>일차
              </div>
            </div>
            <div class="mission-date-groups ms-0">
              <button class="mission-date-item selected">1</button>
              <button class="mission-date-item">2</button>
              <button class="mission-date-item">3</button>
              <button class="mission-date-item">4</button>
              <button class="mission-date-item">5</button>
              <button class="mission-date-item">6</button>
            </div>
          </section>
          <section class="mission-solution-content">
            <div class="mission-solution-header">
              <h4 class="mission-solution-title">1일차 미션</h4>
            </div>
          </section>
          <div class="solution-list" style="padding-bottom: 0">
            <template v-for="(solution, index) in solutions">
              <div v-ripple class="solution-list-item solution-list-item--fixed" :key="index">
                <v-avatar>
                  <v-img :src="getImage(helpfulIcon(solution.helpful))" />
                </v-avatar>
                <div class="unit-info">
                  <b class="unit-name">{{ solution.unitNm }}</b>
                  <span class="unit-type">{{ solution.unitTypeNm }} + {{solution.unitTypeCnt - 1}}</span>
                </div>
              </div>
            </template>
          </div>
        </article>
      </template>
      <span class="tooltip-text" id="tooltipMissionSolutionList">마음여행 일차별 미션을 확인하고<br />오늘의 미션도 바로 해볼 수 있어요!
</span>
    </v-tooltip>
    <slot />
  </v-layout>
</template>

<script>
import {mixinAuth} from '@/mixins'
import MissionCard from '@/components/mission/Card.vue'
import MissionAchievement from '@/components/mission/Achievement.vue'
export default {
  name: 'TutorialSlide7',
  components: {
    MissionCard,
    MissionAchievement
  },
  mixins: [mixinAuth],
  props: ['props'],
  data: () => ({
    tooltipActive: false,
    solutions: [
      {
        unitNm: "안녕! 반가워요😊",
        unitType: "09",
        unitTypeNm: "워크시트형",
        unitTypeCnt: 4,
        helpful: "01,04"
      }
    ]
  }),
  mounted () {
    setTimeout(function () {
      this.tooltipActive = true
    }.bind(this), 300)
  },
  methods: {
    helpfulIcon (helpful) {
      let str = helpful.substr(0, 2)
      return 'ic_condition_white_' + str + '.svg'
    }
  }
}
</script>
<style lang="scss" scoped>
#tutorialGuide07 {
  background-color: #9997F0;
  .mission-main-contents {
    &, *, ::before, ::after {
      box-sizing: border-box;
    }
  }
  .tutorial-guide-content {
    height: 1px;
  }
}
#MissionSolutionList {
  position: absolute;
  z-index: 7;
  top: calc(20dvh + 130px);
  left: 0;
  right: 0;
  margin: 20px;
  box-sizing: border-box;
}
#MissionAchievement {
  position: absolute;
  z-index: 7;
  top: 20dvh;
  left: 0;
  right: 0;
  margin: 20px;
  box-sizing: border-box;
}
.tooltip-coach {
  &, *, ::before, ::after {
    box-sizing: border-box;
  }
  #tooltipMissionSolutionList {
    top: 160px;
    left: 65px;
    &:after {
      transform: scaleY(-1);
      left: -55px;
      top: -12px;
      width: 48px;
      height: 29px;
      background-image: var(--coach-mark-arrow-03);
    }
  }
  #tooltipMissionAchievement {
    top: -90px;
    left: 65px;
    &:after {
      transform: scale(1);
      left: -55px;
      top: 5px;
      width: 48px;
      height: 29px;
      background-image: var(--coach-mark-arrow-03);
    }
  }
}
</style>
